// Track 3: shared funnel_stage / post_kind constants — the single source of
// truth for anywhere in the UI that displays or groups by these fields
// (FindCustomers.jsx, LeadCard.jsx, SavedLeads.jsx). Keeping this in one file
// is deliberate: 3 separate copies of the old `intent` badge logic drifting
// out of sync is exactly the gap that had to be found and fixed to build this.

// Ordered by buying momentum (highest first) — matches the backend prompt's
// own priority: ready > comparing > solution_aware > problem_aware > post_purchase.
export const FUNNEL_STAGE_ORDER = ["ready", "comparing", "solution_aware", "problem_aware", "post_purchase"];

export const FUNNEL_STAGE_META = {
  ready: { label: "Ready to buy", hint: "wants it now — reply with your offer", dot: "bg-green-500" },
  comparing: { label: "Comparing", hint: "weighing options — help them choose", dot: "bg-orange-500" },
  solution_aware: { label: "Exploring", hint: "knows the category, exploring — be genuinely useful", dot: "bg-blue-500" },
  problem_aware: { label: "Problem-aware", hint: "naming the pain — plant your flag, no hard sell", dot: "bg-purple-500" },
  post_purchase: { label: "Existing customer", hint: "already bought — praise, complaint, or follow-up", dot: "bg-pink-500" },
};

// Matches FUNNEL_STAGE_META's dot colors above — the badge on a lead card and
// the stage-group header it sits under must always agree on what each stage
// means visually (ready = green/go, problem_aware = a cooler, earlier-stage hue).
export const FUNNEL_STAGE_BADGE_STYLES = {
  ready: "bg-green-100 text-green-700",
  comparing: "bg-orange-100 text-orange-700",
  solution_aware: "bg-blue-100 text-blue-700",
  problem_aware: "bg-purple-100 text-purple-700",
  post_purchase: "bg-pink-100 text-pink-700",
};

export function funnelStageLabel(stage) {
  return FUNNEL_STAGE_META[stage]?.label || stage || "unclassified";
}

export function funnelStageBadgeClass(stage) {
  return FUNNEL_STAGE_BADGE_STYLES[stage] || "bg-lm-tint text-lm-text2";
}

// Pain Points isn't a separate lens/scan anymore — it's a filter INSIDE Find
// Customers on this field, so a result can be both a real buyer AND flagged
// as venting/frustrated at the same time.
export const PAIN_POST_KINDS = new Set(["pain", "complaint"]);
export const isPainPost = (postKind) => PAIN_POST_KINDS.has(postKind);
